import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Template from "./Template";

const WhatAfter = props => (
  <Template
    subtitle="Co dalej po wypełnieniu ankiety?"
    navigationRight={[
      <button
        onClick={() => {
          props.history.push("/ankieta");
          window.scrollTo(0, 0);
        }}
        className="button is-danger is-medium"
      >
        Start
      </button>
    ]}
    navigationLeft={[
      <button
        onClick={() => {
          props.history.push("/instrukcja");
          window.scrollTo(0, 0);
        }}
        className="button is-medium"
      >
        Wstecz
      </button>
    ]}
  >
    <p>
      Na degustacje produktów będziemy zapraszać Państwa telefonicznie. Podczas
      rozmowy umówimy się na dogodny dzień i godzinę.
    </p>
    <p>
      W trakcie degustacji będą Państwo próbowali produkty z naszego asortymentu
      i oceniali, czy i na ile takie produkty Państwu się podobają. Ocena
      przeprowadzana będzie za pomocą ankiet, które zostaną przygotowane
      specjalnie do tego celu.
    </p>
    <p>
      Degustacja produktów trwać będzie zazwyczaj ok. 40 min. Jeżeli testowanie
      miałoby trwać dłużej, poinformujemy o tym podczas rozmowy telefonicznej.
    </p>
  </Template>
);

WhatAfter.propTypes = {
  history: PropTypes.shape().isRequired
};
export default withRouter(WhatAfter);



// WEBPACK FOOTER //
// ./src/components/pages/WhatAfter.js